import ApiService from './ApiService';

export default class CartAbandonmentService {
  create(data) {
    return ApiService.post('/payments/cart-abandonment', data);
  }
}
